import { FDStack } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { ProgressStepper } from 'Packages/FacetDesign/Components/Experimental/ProgressStepper';

export const ModuleProgressStepper = ({ stepCollection }) => {
  const stepResources = stepCollection?.resources().list();
  const activeStep = stepResources?.findIndex((resource) => resource.isTruthy('isActive'));
  const steps = stepResources.map((step) => ({
    key: step.id(),
    label: step.attr('stepName'),
  }));

  return (
    <FDStack
      direction="row"
      alignItems={'center'}
      justifyContent={'center'}
      width="100%"
      {...dataAttrs('progress-stepper')}
    >
      <ProgressStepper steps={steps} activeStep={activeStep} size={'md'} />
    </FDStack>
  );
};

ModuleProgressStepper.defaultProps = {
};

ModuleProgressStepper.propTypes = {
  stepCollection: PropTypes.instanceOf(fr.Collection).isRequired,
};
